import React from "react";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { usePromotionTracker } from "@danishagro/shared/src/gtm/usePromotionTracker";
import { ImageViewer } from "@danishagro/shared/src/components/molecules/ImageViewer/ImageViewer.component";
import { DA_VideoPlayerViewer } from "../VideoPlayerViewer/VideoPlayerViewer.component";
import { DA_HeroProps } from "./Hero.interface";
import S from "./Hero.module.scss";

export const DA_Hero = (props: DA_HeroProps) => {
    // GTM tracking
    const trackPromotionClick = usePromotionTracker();

    const handleCTAClick = () => {
        if (props.enableTracking) {
            trackPromotionClick({
                creativeName: props?.alias || "",
                promotionId: props?.headline || "",
                promotionName: props?.link.title || "",
            });
        }
        // If you need to do other actions, you can call them here.
    };
    return (
        <div
            className={cn(
                S.wrapper,
                S.layoutCoverBlackFilter,
                S.heroImageLeft,
                props.overlayFullWidth && S.overlayFullWidth
            )}
        >
            <DA_Container
                noVerticalPadding
                noLeftPadding={props.fullWidthMobile}
                noRightPadding={props.fullWidthMobile}
            >
                <div className={cn(S.inner, props.noPaddingTopBottom && S.noPaddingTopBottom)}>
                    {/** Media (Video or Image) */}
                    {props.video ? (
                        <div className={S.videoWrapper}>
                            <DA_VideoPlayerViewer
                                className={S.image}
                                video={props.video}
                                posterStart={props.posterStart}
                            />
                        </div>
                    ) : props.image ? (
                        <div className={S.imageWrapper}>
                            <ImageViewer
                                className={S.image}
                                src={props.image.src}
                                alternative={props?.image.alt}
                                lazy={true}
                                aspectRatioX={Number(props.image?.width)}
                                aspectRatioY={Number(props.image?.height)}
                            />
                        </div>
                    ) : null}

                    {/** Content */}
                    <div className={S.contentWrapper}>
                        <div className={S.content}>
                            {/** Tagline */}
                            {props.tagline ? (
                                <span className={S.tagline}>{props.tagline}</span>
                            ) : null}

                            {/** Title */}
                            {props.headline ? (
                                <DA_Title h1 tag={DA_TitleTag.H1} noMargin fullWidth>
                                    {props.headline}
                                </DA_Title>
                            ) : null}

                            {/** Text */}
                            {props.text ? <DA_Text html={props.text} noPadding /> : null}

                            {/** Buttons */}
                            {props.link.href && (
                                <DA_Button
                                    className={S.readMoreLink}
                                    href={props.link?.href}
                                    title={props.link?.title}
                                    target={props.link?.target}
                                    onClick={handleCTAClick}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </DA_Container>
        </div>
    );
};
